import { NuxtVueI18n } from "nuxt-i18n/types/nuxt-i18n"

export interface NavigationItem {
  link?: {
    text: string
    href: string
    target: string
    linktype?: string
    url?: string
  },
  title?: {
    value: string
  },
  items: NavigationItem[],
  mobileAndTabletOnly?: {
    value: string
  }
}

export interface NavigationColumn {
  name: string
  items: NavigationItem[]
}

export interface ScLanguage {
  name: string
  languageTitle?: {
    value: string
  }
  language?: {
    targetItem: {
      displayName?: string
      code?: string
    }
  }
}

export interface ScLanguages {
  children: ScLanguage[]
}

export interface Language {
  t?: string
  code?: string
  file?: string
}

export enum ThemeColor {
  Light = 'light',
  Dark = 'dark'
}

export interface Theme {
  color: ThemeColor | null
  defaultColor: ThemeColor
}

export interface EnvironmentState {
  webview: boolean
  theme: Theme
  languages: Language[]
  header: {
    items: NavigationItem[]
  }
  footer: {
    currentYear?: {
      value: string
    },
    columns: NavigationColumn[]
  }
}
